(function(){
  // ========== Helpers ==========
  const deb = (fn, ms=60) => { let t; return (...a)=>{ clearTimeout(t); t=setTimeout(()=>fn(...a), ms); }; };

  const normalize = (str) => (str || '')
    .toString()
    .toLowerCase()
    .normalize('NFD').replace(/[\u0300-\u036f]/g, '') // remove diacritics
    .replace(/\s+/g,'-')
    .replace(/[^a-z0-9\-]/g,'');

  // citește opțiunea selectată după nume (Culoare/Orientare etc.)
  const getSelectedOptionByName = (name) => {
    const groups = document.querySelectorAll('.product-form__input, fieldset.js-product-form__option, .product-form__options');
    for (const g of groups){
      const labelEl = g.querySelector('.product-form__option-name, legend, label');
      const labelTxt = labelEl ? labelEl.textContent.trim().toLowerCase() : '';
      if (!labelTxt) continue;
      if (labelTxt.includes(name.toLowerCase())) {
        const checked = g.querySelector('input[type="radio"]:checked');
        if (checked) return checked.getAttribute('data-option-value') || checked.value || checked.nextElementSibling?.textContent?.trim();
        const sel = g.querySelector('select');
        if (sel) return sel.options[sel.selectedIndex]?.text?.trim() || sel.value;
      }
    }
    return null;
  };

  // toate imaginile din galerie (Warehouse variaza markup-ul; folosim selectori largi)
  const productScope = () => document.querySelector('[data-product], .product, .product-main, .product__info-wrapper') || document;
  const allMediaImgs = () => productScope().querySelectorAll(
    '.product__media img[alt], .product-media img[alt], .media img[alt], .swiper-slide img[alt], .product-gallery img[alt], .card__media img[alt]'
  );

  // extrage tokenuri din ALT (acceptă color/colour/culoare + orientare/orientatie/side)
  const extractTokens = (altText) => {
    const alt = (altText || '').toLowerCase();
    const tok = { color: [], orient: [] };
    // culoare
    const colorRegex = /#(?:color|colour|culoare)_([a-z0-9\-]+)/g;
    let m; while ((m = colorRegex.exec(alt)) !== null) { tok.color.push(m[1]); }
    // orientare
    const orientRegex = /#(?:orientare|orientatie|orientation|side)_([a-z0-9\-]+)/g;
    while ((m = orientRegex.exec(alt)) !== null) { tok.orient.push(m[1]); }
    return tok;
  };

  const applyFilter = () => {
    // opțiuni selectate
    const colorRaw = getSelectedOptionByName('Culoare') || getSelectedOptionByName('Color') || getSelectedOptionByName('Colour') || '';
    const orientRaw = getSelectedOptionByName('Orientare') || getSelectedOptionByName('Orientatie') || getSelectedOptionByName('Orientation') || '';
    const colorSel = normalize(colorRaw);
    const orientSel = normalize(orientRaw);

    const imgs = allMediaImgs();
    if (!imgs.length) return;

    // pre-scanăm imaginile și notăm ce tokenuri au
    const meta = Array.from(imgs).map(img => {
      const tok = extractTokens(img.getAttribute('alt'));
      return { img, colorTokens: tok.color, orientTokens: tok.orient };
    });

    // determinăm ce fel de potriviri există în set
    const existsBoth = meta.some(it => it.colorTokens.includes(colorSel) && it.orientTokens.includes(orientSel));
    const existsColorOnly = colorSel && meta.some(it => it.colorTokens.includes(colorSel));
    const existsOrientOnly = orientSel && meta.some(it => it.orientTokens.includes(orientSel));

    // regulă de filtrare: preferăm ambele > doar culoare > doar orientare > nimic
    meta.forEach(({ img, colorTokens, orientTokens }) => {
      let show = true;
      if (existsBoth) {
        show = colorTokens.includes(colorSel) && orientTokens.includes(orientSel);
      } else if (existsColorOnly) {
        show = colorTokens.includes(colorSel);
      } else if (existsOrientOnly) {
        show = orientTokens.includes(orientSel);
      } else {
        show = true; // fallback: nu filtrăm
      }
      const mediaItem = img.closest('.product__media, .product-media, .media, .swiper-slide, li, div');
      if (mediaItem) {
        mediaItem.style.display = show ? '' : 'none';
      } else {
        img.style.display = show ? '' : 'none';
      }
    });
  };

  const applyFilterDeb = deb(applyFilter, 60);

  function bindListeners(){
    const root = productScope();
    if (!root) return;
    root.addEventListener('change', e=>{
      if (e.target.closest('.product-form__input, fieldset, .product-form__options')) applyFilterDeb();
    });
    document.addEventListener('variant:change', applyFilterDeb, true);
  }

  function init(){
    bindListeners();
    applyFilterDeb();
    const obs = new MutationObserver(applyFilterDeb);
    obs.observe(productScope() || document.body, { childList:true, subtree:true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
